import React, {Fragment} from 'react';
import PropTypes from "prop-types";
import css from 'scss';

import {isIE} from '../../../base/common';

const getFontSize = (percent) => {
    let size = 0;
    percent = parseInt(percent);

    if (percent > 60) {
        size = 55;
    } else if (percent > 40) {
        size = 42;
    } else if (percent > 20) {
        size = 27;
    } else {
        size = 18;
    }
    return size;
};
const yellow = css['$color-yellow'];
const white = css['$color-white'];

const Circle = (props) => {
    return (
        <g className="answer_circle" transform={`translate(${props.x}, ${props.y})`}>
            <circle fill={props.selected ? yellow : white} cx={props.radius} cy={props.radius} r={props.radius}/>
            {isIE() ?
                <text className="answer__text ie" transform={`translate(${props.radius}, ${props.radius})`}
                      fill={props.textColor}
                      fontSize={`${getFontSize(props.textSize)}px`}
                      textAnchor="middle" dominantBaseline="middle">
                    {props.text}
                </text>
                :
                    <Fragment>
                        <text className="answer__text desktop" transform={`translate(${props.radius}, ${props.radius}) rotate(-46 0 0)`}
                              fill={props.textColor}
                              fontSize={`${getFontSize(props.textSize)}px`}
                              textAnchor="middle" dominantBaseline="middle">
                            {props.text}
                        </text>
                        <text className="answer__text mobile" transform={`translate(${props.radius}, ${props.radius}) rotate(-137 0 0)`}
                              fill={props.textColor}
                              fontSize={`${getFontSize(props.textSize)}px`}
                              textAnchor="middle" dominantBaseline="middle">
                            {props.text}
                        </text>
                    </Fragment>
            }
        </g>
    );
};

export default Circle;

Circle.defaultProps = {
    x: 0,
    y: 0,
    radius: 200,
    fill: '#fff',
    text: 'tekst domyśny',
    textSize: 30,
    textColor: '#1D1D1B',
};

Circle.propTypes = {
    x: PropTypes.number,
    y: PropTypes.number,
    radius: PropTypes.number.isRequired,
    fill: PropTypes.string,
    text: PropTypes.string,
    textSize: PropTypes.number,
    textColor: PropTypes.string
};


// WEBPACK FOOTER //
// ./sources/js/components/Question/graph/Circle.js